<template>
  <section class="section section-lg pt-3">
    <div class="">
      <div id="about-us" class=" pt-2">
        <div class="row align-items-center justify-content-md-center">
          <div class="col-md-9 text-md-start">
            <div class="row align-items-center">
              <div class="col-lg-12">
                <h3 class="fw-bold pb-2">{{ $t("Trusted Homecare, Right Where You Need It") }}</h3>
                <p class="lead  mt-3">
                  {{ $t("ABOUT_US_DESC") }}<br>
                  <br>
                  {{ $t("ABOUT_US_DESC_SEC") }}
                </p>

<!--                <img class="pt-5" width="300" src="@/assets/fullLogo.png" alt="">-->
              </div>
            </div>
          </div>
        </div>

              <div class="row align-items-start justify-content-md-center pt-6 lead mb-4">
                <div class="col-md-5 offset-md-1 text-start">
                  <h3 class="text-dark">
                    <i class="bi-check-circle-fill color me-1 position-relative" style="top: 2px"></i>
                    {{ $t("Our Mission") }}
                  </h3>

                  <p>
                    {{ $t("We aim to transform the way healthcare is delivered by making home-based safe, reliable, and truly patient-focused.") }}<br>
                  </p>
                </div>

                <div class="col-md-5 ps-md-5 text-start">
                  <h3 class="text-dark">
                    <i class="bi-check-circle-fill color me-1 position-relative" style="top: 2px"></i>
                    {{ $t("Our Vision" ) }}
                  </h3>

                  <p>
                    {{ $t("We strive to become the leading platform for home-based healthcare in Cyprus and beyond. Everyone deserves access to trusted care without having to leave home.") }}<br>
                  </p>
                </div>
              </div>

        <div class="align-items-center justify-content-md-center pt-6 text-start" style="    background-color: #960e451f;">
          <!-- Feature Box

                            ============================================= -->
<div class="row ps-4 pe-4 text-center">
          <div class="col-lg-3 col-md-6 mb-4">
<h4 class="mb-3 fw-bold">{{ $t("Compassion") }}</h4>

            <p class="text-muted">
              {{ $t("We treat every individual with dignity and respect.") }}
            </p>
          </div>

          <div class="col-lg-3 col-md-6 mb-4">
<h4 class="mb-3 fw-bold">{{ $t("Trust") }}</h4>

            <p class="text-muted">
              {{ $t("All healthcare providers on our platform are licensed and carefully selected.") }}
            </p>
          </div>

          <div class="col-lg-3 col-md-6 mb-4">
<h4 class="mb-3 fw-bold">{{ $t("Simplicity") }}</h4>

            <p class="text-muted">
              {{ $t("We make accessing care as easy and seamless as possible.") }}
            </p>
          </div>

          <div class="col-lg-3 col-md-6 mb-4">
<h4 class="mb-3 fw-bold">{{ $t("Excellence") }}</h4>

            <p class="text-muted">
              {{ $t("Our goal is to deliver medical services that meet the highest standards of quality.") }}
            </p>
          </div>
</div>
        </div>

        <div class="row align-items-center justify-content-md-center pt-6">
          <div class="col-md-9 text-md-start">
            <div class="row align-items-center">
              <div class="col-lg-12">
                <h3 class="fw-bold pb-2">{{ $t("What We Offer") }}</h3>
                <p class="lead  mt-3">
                  {{ $t("We provide personalised in-home care tailored to your medical needs. Our network includes experienced, vetted professionals you can trust. Through our app, you can easily book and manage healthcare visits. We offer coverage across major cities and regions of Cyprus. Every service is delivered with professionalism and genuine care.") }}<br>
                </p>
              </div>
            </div>
          </div>
        </div>
        </div>
    </div>
  </section>
</template>
<script>

export default {
  name: "AboutUs",
  components: {}
}
</script>

<style scoped>

</style>